import GreenDot from "@/assets/icons/GreenDot.svg";
import { ReactNode } from "react";
export const ProgressBadge = () => {
  return (
    <div className="flex items-center gap-x-[2px] px-2 py-[2px] bg-[#ECFDF3] rounded-full">
      <GreenDot />
      <p className="text-[#027143] font-medium text-caption2-medium">
        In Progress
      </p>
    </div>
  );
};

type BadgeProps = {
  type: "Neutral" | "Success" | "Pending";
  children: ReactNode;
};
export const Badge = ({ type, children }: BadgeProps) => {
  const getClassNames = () => {
    switch (type) {
      case "Success":
        return "bg-[#E9F5EF] text-[#1D7100]";
      case "Pending":
        return "bg-[#DFEAF4] text-[#003471]";
      case "Neutral":
        return "text-[#475467] bg-gray-200";
      default:
        return "bg-gray-200 text-gray-80";
    }
  };
  return (
    <div
      className={`text-xs w-fit text-center font-medium flex items-center px-2 py-1 rounded-full gap-x-1 ${getClassNames()}`}
    >
      {children}
    </div>
  );
};
